import { render, staticRenderFns } from "./transaction-biller-response.vue?vue&type=template&id=d24cc5fa&"
import script from "./transaction-biller-response.vue?vue&type=script&lang=js&"
export * from "./transaction-biller-response.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports